import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Link } from 'react-router-dom';
// import { Typography } from 'antd';
import { stripHtml } from '../utils';
import { withRedux } from '../hoc';
import { BackgroundImage, Button } from '../components';

// const { Paragraph } = Typography;

const mapStateToProps = state => {
  return {
    t: _.get(state, 't'),
    language: _.get(state, 'language')
  };
};

@withRedux(mapStateToProps)
class ArticleItem extends PureComponent {
  static propTypes = {
    data: PropTypes.shape(),
    showDate: PropTypes.bool,
    darkFont: PropTypes.bool,
    pathOnClick: PropTypes.string
  };
  static defaultProps = {
    data: {
      image: 'https://www.bangkokpost.com/media/content/20150509/c1_556251_620x413.jpg',
      title: 'Lorem ipsum',
      description:
        'Lorem ipsum dolor sit amet,ddd The long word will break and wrap to the next line., sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
      date: '12 Sep 2018'
    },
    showDate: false,
    darkFont: false,
    pathOnClick: ''
  };

  render() {
    const { data, showDate, darkFont, pathOnClick, t } = this.props;
    let dateItem = _.get(data, 'date');
    if(_.get(data, 'promotion_start_time') === null || _.get(data, 'promotion_start_time') === null){
      dateItem = ''
    }
    return (
      <div className="article-item-component">
        <Link to={pathOnClick}>
          <div className="container-img">
            <BackgroundImage image={_.get(data, 'image')} className="img" />
            <div className="container-button">
              <Button ghost>
                Read More <i className="fa fa-arrow-right" />
              </Button>
            </div>
          </div>
        </Link>
        <div className={`article-title ${darkFont ? 'dark' : ''}`}>{t(_.get(data, 'title'))}</div>
        {/* <Paragraph ellipsis> */}
          <div className={`article-content ${darkFont ? 'dark' : ''}`}>
            <p className="benefits-detail" dangerouslySetInnerHTML={{ __html: stripHtml(t(_.get(data, 'description'))) }} />
          </div>
        {/* </Paragraph> */}
        {showDate && <div className={`article-date ${darkFont ? 'dark-date-color' : ''}`}>{dateItem}</div>}
      </div>
    );
  }
}

export default ArticleItem;



// WEBPACK FOOTER //
// ./src/components/ArticleItem.js